export function systemClock() {
    return { now: () => Date.now() };
}
function webCrypto() {
    const candidate = globalThis.crypto;
    return typeof candidate === 'object' ? candidate : undefined;
}
let fallbackCounter = 0;
/**
 * A unique-enough string, by the best means available here.
 *
 * These are local identifiers, not secrets and not tokens — nothing authorises anything by
 * holding one. What they must be is *distinct*, including across two devices editing offline that
 * later merge, which is why the fallback mixes a clock, a counter and randomness rather than
 * relying on any one of the three.
 */
function randomId() {
    const source = webCrypto();
    if (typeof source?.randomUUID === 'function')
        return source.randomUUID();
    if (typeof source?.getRandomValues === 'function') {
        const bytes = source.getRandomValues(new Uint8Array(16));
        return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    }
    // Reached only where WebCrypto is absent — some React Native runtimes, some embedded webviews.
    // Weaker, and deliberately not silent about being the last resort.
    fallbackCounter += 1;
    const random = Math.random().toString(36).slice(2, 10);
    return `${Date.now().toString(36)}-${fallbackCounter.toString(36)}-${random}`;
}
export function randomIds() {
    return {
        nodeId: () => `n_${randomId()}`,
        edgeId: () => `e_${randomId()}`,
        attachmentId: () => `att_${randomId()}`,
        operationId: () => `op_${randomId()}`,
    };
}
/**
 * A counter and a fixed clock.
 *
 * Exported from the package rather than kept in the tests, because every consumer's tests need
 * the same thing, and a second implementation of "deterministic ids" is a second thing to keep
 * in step with the first.
 */
export function deterministicEnvironment(input) {
    const tick = input.tickMs ?? 1;
    let elapsed = 0;
    let nodes = 0;
    let edges = 0;
    let attachments = 0;
    let operations = 0;
    return {
        authorId: input.authorId,
        clock: {
            now: () => {
                const value = (input.startAt + elapsed);
                elapsed += tick;
                return value;
            },
        },
        ids: {
            nodeId: () => `n${String((nodes += 1))}`,
            edgeId: () => `e${String((edges += 1))}`,
            attachmentId: () => `att${String((attachments += 1))}`,
            operationId: () => `op${String((operations += 1))}`,
        },
        reset: () => {
            elapsed = 0;
            nodes = 0;
            edges = 0;
            attachments = 0;
            operations = 0;
        },
    };
}
//# sourceMappingURL=environment.js.map